/**
 * Agency-configured Category/Role/Sector options for onboarding short-link
 * resolution and the Task Library filter dropdown. These are per-agency
 * data, not a global taxonomy.
 *
 * Fetched via GET /onboarding-axis-options (backend/src/routes/onboardingAxisOptions) —
 * a dedicated endpoint for this app's session. The existing `/agency/job-sectors`
 * and `/manageprompt/allcategory` endpoints look like they'd do this, but both
 * require `Authenticate` (an agency-admin JWT resolved against AgencyModel) and
 * 401 for every legitimate chat-app (social-calendar) session, which carries a
 * ChatUser-scoped token instead — see that backend route's services.js comment.
 * This endpoint uses AuthenticateChatUser and derives agency_id from the
 * session itself, so no agency id needs to be passed from here at all.
 */
import { useQuery } from "@tanstack/react-query";
import { request, ReqMethods } from "../lib/apiClient";

const { GET } = ReqMethods;

export const agencyAxisOptionsKeys = {
  all: ["agencyAxisOptions"],
};

/** `{ categories, roles, sectors }`, each `[{name, id}]`, for the current session's agency. */
export function useAgencyAxisOptions({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: agencyAxisOptionsKeys.all,
    queryFn: async () => {
      const res = await request(GET, "/onboarding-axis-options");
      return res?.data || {};
    },
    enabled,
  });
  return {
    categories: query.data?.categories || [],
    roles: query.data?.roles || [],
    sectors: query.data?.sectors || [],
    isLoading: query.isLoading,
  };
}
